import { useTranslation } from 'react-i18next'

import LoadingIndicator from '@/widgets/LoadingIndicator'
import RozmowaActionsCard from './RozmowaActionsCard'
import RozmowaDetailsCard from './RozmowaDetailsCard'
import RozmowaOsobaCard from './RozmowaOsobaCard'
import RozmowaAnalysisSections from './RozmowaAnalysisSections'
import RozmowaNoteSection from './RozmowaNoteSection'
import useRozmowaDetailsEdit from './hooks/useRozmowaDetailsEdit'
import useRozmowaDetailsPage from './hooks/useRozmowaDetailsPage'

export default function RozmowaDetails() {
	const { t } = useTranslation()
	const { deleting, error, handleBack, handleDelete, handleEdit, handleSaveFields, loading, rozmowa } = useRozmowaDetailsPage()
	const {
		editing,
		noteValue,
		nextConversationValue,
		salesOpportunityValue,
		saving,
		saveError,
		handleStartEdit,
		handleCancelEdit,
		handleSave,
		setNoteValue,
		setNextConversationValue,
		setSalesOpportunityValue,
	} = useRozmowaDetailsEdit(rozmowa, handleSaveFields)

	if (loading) return <LoadingIndicator message={t('conversations.details.loading')} />

	if (error) {
		return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
	}

	if (!rozmowa) {
		return <div className="min-h-screen flex items-center justify-center">{t('conversations.details.notFound')}</div>
	}

	return (
		<div>
			<RozmowaDetailsCard
				rozmowa={rozmowa}
				onBack={handleBack}
				onEdit={handleEdit}
				onDelete={handleDelete}
				deleting={deleting}
			/>
			<RozmowaOsobaCard rozmowa={rozmowa} />
			<RozmowaNoteSection
				rozmowa={rozmowa}
				editing={editing}
				noteValue={noteValue}
				nextConversationValue={nextConversationValue}
				salesOpportunityValue={salesOpportunityValue}
				saving={saving}
				saveError={saveError}
				onCancel={handleCancelEdit}
				onSave={handleSave}
				onNoteChange={setNoteValue}
				onNextConversationChange={setNextConversationValue}
				onSalesOpportunityChange={setSalesOpportunityValue}
				onStartEdit={handleStartEdit}
			/>
			<RozmowaActionsCard rozmowa={rozmowa} />
			<RozmowaAnalysisSections rozmowa={rozmowa} />
		</div>
	)
}
